import c1 from "./1.svg";
import c2 from "./2.svg";
import c3 from "./3.svg";
import c4 from "./4.svg";

export const characters = [null, c1, c2, c3, c4];
